export const selectModalState = (state) => state.modal.showModal;
